// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DynamicContactCard Styles */

.scl--web-component-dynamic-contact-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 83px;
  width: 100%;
  height: 328px;
}

/* Icon wrapper */
.scl--web-component-dynamic-contact-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43px;
  height: 43px;
  flex: none;
}

.scl--web-component-dynamic-contact-card-icon img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scl--web-component-dynamic-contact-card-icon svg {
  width: 43px;
  height: 43px;
}

/* Content section */
.scl--web-component-dynamic-contact-card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 30px;
  gap: 29px;
  width: 100%;
  flex: 1;
}

/* Title with gradient text */
.scl--web-component-dynamic-contact-card-title {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 100%;
  text-transform: capitalize;
  margin: 0;
  background: linear-gradient(204.02deg, #FFFFFF 27.81%, #C9C9C9 84.59%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  flex: none;
  align-self: stretch;
}

/* Description text */
.scl--web-component-dynamic-contact-card-description {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 150%;
  color: #969EAA;
  margin: 0;
  flex: none;
  align-self: stretch;
}

/* Button (RoundButton override) */
.scl--web-component-dynamic-contact-card-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 11px;
  min-width: 158px;
  height: 40px;
  border: 1.5px solid #797979;
  border-radius: 20px;
  flex: none;
  margin-top: auto;
}

.scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
}

/* Responsive Design */
@media (max-width: 850px) {
  .scl--web-component-dynamic-contact-card {
    height: auto;
    min-height: 328px;
    gap: 60px;
  }

  .scl--web-component-dynamic-contact-card-content {
    padding-right: 0;
  }
}

@media (max-width: 500px) {
  .scl--web-component-dynamic-contact-card {
    height: auto;
    min-height: auto;
    gap: 40px;
  }

  .scl--web-component-dynamic-contact-card-content {
    gap: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/contact/css/dynamicContactCard.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,OAAO;AACT;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;EACT,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* DynamicContactCard Styles */\n\n.scl--web-component-dynamic-contact-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0;\n  gap: 83px;\n  width: 100%;\n  height: 328px;\n}\n\n/* Icon wrapper */\n.scl--web-component-dynamic-contact-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 43px;\n  height: 43px;\n  flex: none;\n}\n\n.scl--web-component-dynamic-contact-card-icon img{\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.scl--web-component-dynamic-contact-card-icon svg {\n  width: 43px;\n  height: 43px;\n}\n\n/* Content section */\n.scl--web-component-dynamic-contact-card-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-right: 30px;\n  gap: 29px;\n  width: 100%;\n  flex: 1;\n}\n\n/* Title with gradient text */\n.scl--web-component-dynamic-contact-card-title {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 100%;\n  text-transform: capitalize;\n  margin: 0;\n  background: linear-gradient(204.02deg, #FFFFFF 27.81%, #C9C9C9 84.59%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  flex: none;\n  align-self: stretch;\n}\n\n/* Description text */\n.scl--web-component-dynamic-contact-card-description {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 150%;\n  color: #969EAA;\n  margin: 0;\n  flex: none;\n  align-self: stretch;\n}\n\n/* Button (RoundButton override) */\n.scl--web-component-dynamic-contact-card-button {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 11px;\n  min-width: 158px;\n  height: 40px;\n  border: 1.5px solid #797979;\n  border-radius: 20px;\n  flex: none;\n  margin-top: auto;\n}\n\n.scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color: #FFFFFF;\n}\n\n/* Responsive Design */\n@media (max-width: 850px) {\n  .scl--web-component-dynamic-contact-card {\n    height: auto;\n    min-height: 328px;\n    gap: 60px;\n  }\n\n  .scl--web-component-dynamic-contact-card-content {\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 500px) {\n  .scl--web-component-dynamic-contact-card {\n    height: auto;\n    min-height: auto;\n    gap: 40px;\n  }\n\n  .scl--web-component-dynamic-contact-card-content {\n    gap: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
